module.exports = __webpack_public_path__ + "img/pdf.8e5a3393.svg";